import SnapshotModal from "./SnapshotModal";

export default SnapshotModal;
